/**
 * Browser features newer libraries assume. pdf.js 5 (the in-browser CV reader) calls
 * Promise.withResolvers, which Safari added in iOS 17.4 and Chrome in 119; without it older
 * phones fall back to a much weaker reader and get poor ATS scores.
 */
type WithResolvers = <T>() => { promise: Promise<T>; resolve: (value: T | PromiseLike<T>) => void; reject: (reason?: unknown) => void };

const P = Promise as unknown as { withResolvers?: WithResolvers };
if (typeof P.withResolvers !== "function") {
  P.withResolvers = function withResolvers<T>() {
    let resolve!: (value: T | PromiseLike<T>) => void;
    let reject!: (reason?: unknown) => void;
    const promise = new Promise<T>((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve, reject };
  };
}

export {};
